require('./bootstrap');

export const departureReservationScripts = function () {

    $(".submitDRPayment").on("click", function () {
        if (!confirm("Submit Payment?")) {
            return
        }
        let form = $("#drPaymentForm")
        let url = form[0]['action']
        let data = new FormData(form[0])
        let button = $(this)[0]
        data.append('type', button.dataset.paymentAmount)
        $.post({
            url: url,
            method: "POST",
            data: data,
            processData: false,
            contentType: false,
            success: function (r) {
                console.log(r)
                if (r.success) {
                    window.location.reload()
                }
                switch (r.response.transaction_status) {
                    case 'declined':
                        alert("Card Declined");
                        break
                }
            },
            error: function (error) {
                alert(error.responseJSON.message)
            }
        })
    });

    $(".clientBillingSelect").on("change", function (e) {
        $("input#client_billing_id").val(this.value)
    });
}